import { useEffect, useState } from 'react';

import Image from './Image';

import CommonLightbox from './CommonLightbox';

import FIREBASE from '../../../util/Firebase';
import { LOGGER } from '../../../util/Logging';

/**
 * An image that is pulled from firebase.
 * The src property points to a file in firebase storage.
 * @returns The components for the avatar
 */
export default function FirebaseImage(props) {
  const [imgSrc, setImgSrc] = useState('');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const { alt, src, sx, ...other } = props;

  useEffect(() => {
    (async () => {
      try {
        const s = await FIREBASE.getStorage().getDownloadUrl(src);
        setImgSrc(s);
      } catch (e) {
        LOGGER.error(e);
        setImgSrc('');
      }
    })();
  }, [src]);

  return (
    <>
      {lightboxOpen && (
        <CommonLightbox
          imgSrc={imgSrc}
          onClose={() => {
            setLightboxOpen(false);
          }}
        />
      )}
      <Image
        alt={alt}
        src={imgSrc}
        sx={{
          ...sx,
          cursor: 'pointer',
          '@media (hover: hover)': {
            '&:hover': {
              transform: 'scale(1.05)',
            },
          },
          transition: 'all .4s ease-in-out',
        }}
        {...other}
        onClick={() => {
          setLightboxOpen(true);
        }}
      />
    </>
  );
}
